/**
 * Created by M.J. van der Werf <vanderwerf@bluehorizon.nl> on 20-12-17.
 */

const nop = {
    type: "NO_OPERATION"
};
export default nop;
